import React, { useMemo } from 'react';
import { Modal, Spin, Select, Form, Typography } from 'antd';

const { Paragraph } = Typography;

export interface AgentSkillContentModalProps {
  open: boolean;
  title: string;
  onCancel: () => void;
  skillBundles: string[];
  selectedSkillBundle: string | null;
  onSelectBundle: (bundle: string) => void | Promise<void>;
  skillLoading: boolean;
  skillBody: string | null;
  skillPaths: string[];
  skillTruncated: boolean;
}

/**
 * Modal to inspect repo SKILL markdown for one or more skill_bundle slugs (operator UI).
 */
export const AgentSkillContentModal: React.FC<AgentSkillContentModalProps> = ({
  open,
  title,
  onCancel,
  skillBundles,
  selectedSkillBundle,
  onSelectBundle,
  skillLoading,
  skillBody,
  skillPaths,
  skillTruncated,
}) => {
  const selectOptions = useMemo(
    () => skillBundles.map((b) => ({ label: b, value: b })),
    [skillBundles]
  );

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      footer={null}
      width="90vw"
      style={{ top: 24 }}
      destroyOnClose
    >
      {skillBundles.length > 1 && selectedSkillBundle && (
        <Form.Item label="Skill bundle" style={{ marginBottom: 16 }}>
          <Select
            aria-label="Skill bundle"
            style={{ minWidth: 280 }}
            value={selectedSkillBundle}
            options={selectOptions}
            onChange={(v) => {
              void onSelectBundle(String(v));
            }}
          />
        </Form.Item>
      )}
      {skillTruncated && (
        <Paragraph type="warning">Response was truncated for size limits.</Paragraph>
      )}
      {skillPaths.length > 0 && (
        <Paragraph type="secondary" copyable={{ text: skillPaths.join('\n') }}>
          <strong>Paths:</strong> {skillPaths.join(', ')}
        </Paragraph>
      )}
      <Spin spinning={skillLoading}>
        <pre
          style={{
            maxHeight: '70vh',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            fontSize: 12,
            background: 'var(--ant-color-fill-quaternary, #f5f5f5)',
            padding: 12,
            borderRadius: 8,
          }}
        >
          {skillBody ?? ''}
        </pre>
      </Spin>
    </Modal>
  );
};
